import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { formalDimensions, pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonVideo: {
    /* position: 'absolute',
    top: pixelDimensions(35),
    left: pixelDimensions(35), */
  },
  iconVideo: {
    fontSize: pixelDimensions(30),
    color: appColors.primary,
  },
  viewBase: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    marginHorizontal: formalDimensions(3),
    height: '80%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  video: {
    alignSelf: 'center',
    width: pixelDimensions(80),
    aspectRatio: 1,
    marginTop: formalDimensions(4),
    marginBottom: formalDimensions(2),
  },
  button: {
    marginVertical: pixelDimensions(3),
    backgroundColor: appColors.primary,
  },
  textButton: {
    color: Colors.white,
    textAlign: 'center',
    fontSize: formalDimensions(3),
    fontFamily: 'MBold',
  },
  title: {
    fontSize: formalDimensions(4),
    marginTop: formalDimensions(1),
  },
  logo: {
    marginTop: pixelDimensions(5),
    height: pixelDimensions(20),
    width: pixelDimensions(20) * (75 / 22),
  },
  cardContent: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewWhiteBack: {
    left: '20%',
    top: '20%',
    position: 'absolute',
    backgroundColor: Colors.white,
    height: pixelDimensions(15),
    width: pixelDimensions(15),
  },
});

export default styles;
